import { Box, Text } from '@chakra-ui/react';
import { Formik, FormikProps, Form } from 'formik';
import React from 'react';

import { SignupFormValues } from 'types/dashboard.d';

import {
  InputFormField,
  FormSubmitButton,
} from 'packages/common-frontend/components/FormField';
import { useSignupFormManagement } from 'packages/logged-out/hooks/useSignupFormManagement';

type SignupProps = { onSubmit: () => void };
export const SignupForm = ({ onSubmit }: SignupProps) => {
  const {
    initialValues,
    handleSubmit,
    formValidation,
  } = useSignupFormManagement();
  return (
    <Box
      textAlign="center"
      width="100%"
      mb={{ base: 12, md: 0 }}
      padding={['0 20px', '0 20px', '0 20px', '0 20px']}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={async (values) => {
          await handleSubmit(values);
          onSubmit();
        }}
        validationSchema={formValidation}
      >
        {(formProps: FormikProps<SignupFormValues>) => {
          return (
            <Form onSubmit={formProps.handleSubmit}>
              <Text
                mt="10px"
                mb="10px"
                fontSize="xl"
                align="left"
                fontWeight="600"
              >
                Create your Finley account
              </Text>
              <InputFormField
                isRequired
                propName="email"
                type="email"
                label="Email"
                inputWidth="lg"
                placeholder="john@email.com"
                formProps={formProps}
                marginTop={6}
              />
              <InputFormField
                isRequired
                propName="password"
                type="password"
                placeholder="********"
                inputWidth="lg"
                label="Password"
                formProps={formProps}
                marginTop={6}
              />
              <InputFormField
                isRequired
                propName="passwordConfirmation"
                label="Confirm Password"
                type="password"
                placeholder="********"
                inputWidth="lg"
                formProps={formProps}
                marginTop={6}
              />
              <FormSubmitButton
                isSubmitting={formProps.isSubmitting}
                width="full"
              >
                Create Account
              </FormSubmitButton>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};
